// Convert image paths to root-relative URLs (resolved against the current origin)
export const getImageUrl = (imagePath) => {
  if (!imagePath) return null;
  if (imagePath.startsWith('http')) return imagePath;
  
  // Handle different path formats
  let cleanPath = imagePath;
  if (imagePath.startsWith('/storage/')) {
    // Laravel storage path - keep as is
    cleanPath = imagePath;
  } else if (imagePath.startsWith('storage/')) {
    // Add leading slash
    cleanPath = `/${imagePath}`;
  } else if (!imagePath.startsWith('/')) {
    // Add leading slash if missing
    cleanPath = `/${imagePath}`;
  }
  
  return cleanPath;
};

// Format date for HTML date inputs (YYYY-MM-DD)
export const formatDateForInput = (dateString) => {
  if (!dateString) return '';
  
  try {
    // Handle different date formats
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '';
    
    // Convert to YYYY-MM-DD format
    return date.toISOString().split('T')[0];
  } catch (error) {
    console.warn('Error formatting date:', dateString, error);
    return '';
  }
};

// Format date for display
export const formatDateForDisplay = (dateString) => {
  if (!dateString) return 'Not provided';
  
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return 'Invalid date';
    
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  } catch (error) {
    console.warn('Error formatting date for display:', dateString, error);
    return 'Invalid date';
  }
};

// Validate image file
export const validateImageFile = (file) => {
  const errors = [];
  
  // Check file type
  const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif', 'image/webp'];
  if (!allowedTypes.includes(file.type)) {
    errors.push('Please select a valid image file (JPEG, PNG, JPG, GIF, or WebP)');
  }
  
  // Check file size (2MB limit)
  const maxSize = 2 * 1024 * 1024; // 2MB in bytes
  if (file.size > maxSize) {
    errors.push('Image size must be less than 2MB');
  }
  
  return {
    isValid: errors.length === 0,
    errors
  };
};

export default {
  getImageUrl,
  formatDateForInput,
  formatDateForDisplay,
  validateImageFile
};